export default "__VITE_ASSET__BNtiO6xg__"